import React from 'react'
import './collections_sub.css'
import Footer from '../../Home/Home_modules/Footerr/footer'
import Pnvivek from '../../Home/Home_modules/pnvivek';
import topbanner from './Im/pnvivek.jpg'
import topimg from './Im/chandthumb.jpg'
import thumb_vivek from './Im/thumb_vivek.JPG'

function PasumaiNayaganVivek() {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 30
        }
      };
    return (
        <div>
            <div className="collections-sub-top">
                <img src={topbanner} />
            </div>
            <div className="collections-sub-top2">
                <img src={thumb_vivek} />
                <h1>Pasumai Nayagan Vivek</h1>
                <p>Vivekanandan (19 November 1961 – 17 April 2021), known professionally as Vivek, was an Indian actor, comedian, television personality, playback singer and social activist working in the Tamil film industry. In 2010, Vivek launched Green Kalam, a project to plant trees across India inspired by former President of India A. P. J. Abdul Kalam. Through Twitter, he mobilised volunteers, particularly from schools and colleges, to join the initiative. Kalam insisted the project should not be named after him, after which Vivek briefly changed its name to Green Globe. As of his death, over 3,300,000 saplings had been planted. This project aims to honour the “Green Globe”initiative and career, by giving the NFT holder a sapling or seed to plant</p>
                <div className="collections-sub-topbtns">
                <button className="collections-sub-sharebtn"><i className="fas fa-share"></i></button><button className="collections-sub-sharebtn"><i className="fas fa-ellipsis-h"></i></button>
                </div>
            </div>
            <div className="explore">
              
           <div className="collection-explore-d">
           <Pnvivek />
</div>
</div>
        <Footer/>
        </div>
    )
}

export default PasumaiNayaganVivek
